/**
 * Arabic for the service provider contracts register.
 * Proposed; pending native review.
 */
const ar: Record<string, string> = {
  "Service provider contracts": "عقود مقدمي الخدمات",
  "Every provider's scope, service levels, term and notice deadline, with the signed copy attached. No financial terms: the register refuses a price, a rate or an amount, and the signed copy is filed in the document library as a restricted document.":
    "نطاق كل مقدم خدمة ومستويات الخدمة والمدة وموعد الإشعار، مع النسخة الموقّعة مرفقة. بلا شروط مالية: يرفض السجل أي سعر أو تعرفة أو مبلغ، وتُحفظ النسخة الموقّعة في مكتبة الوثائق كوثيقة مقيّدة.",
  "Add a contract": "أضف عقداً",
  "Sample contracts — replace them with the airport's own.": "عقود نموذجية — استبدلها بعقود المطار الفعلية.",
  contracts: "عقود",
  "notice decisions due": "قرارات إشعار مستحقة",
  "within {d} days of the notice deadline": "خلال {d} يوماً من موعد الإشعار",
  "within {d} days": "خلال {d} يوماً",
  "a provider working without a contract in force": "مقدم خدمة يعمل دون عقد ساري",
  "without a signed copy": "دون نسخة موقّعة",
  "nothing to check the terms against": "لا شيء تُقارن به الشروط",
  "service levels recorded": "مستويات خدمة مسجّلة",
  "across every contract": "في كل العقود",
  "provider, service, reference": "مقدم الخدمة، الخدمة، المرجع",
  "Type of provider": "نوع مقدم الخدمة",
  Standing: "الوضع",
  "Every contract": "كل العقود",
  Term: "المدة",
  "Notice by": "الإشعار قبل",
  "Service levels": "مستويات الخدمة",
  "Signed copy": "النسخة الموقّعة",
  "ended {n} days ago": "انتهى قبل {n} يوماً",
  "{n} days left": "متبقٍ {n} يوماً",
  "passed {n} days ago": "فات قبل {n} يوماً",
  "No contract matches.": "لا يوجد عقد مطابق.",
  "The signed copy is in the document library, as a restricted document; open it there.":
    "النسخة الموقّعة في مكتبة الوثائق كوثيقة مقيّدة؛ افتحها من هناك.",
  "This browser holds no copy of the signed contract.": "لا يحتفظ هذا المتصفح بنسخة من العقد الموقّع.",
  "Open the signed copy": "افتح النسخة الموقّعة",
  "Save a copy": "احفظ نسخة",
  Services: "الخدمات",
  "Not in scope": "خارج النطاق",
  Expiry: "الانتهاء",
  "Notice period": "مدة الإشعار",
  Renewal: "التجديد",
  "Contract owner": "مسؤول العقد",
  "Provider contact": "جهة اتصال مقدم الخدمة",
  "No service levels recorded.": "لا توجد مستويات خدمة مسجّلة.",
  "What is measured": "ما يُقاس",
  Standard: "المعيار",
  Reported: "يُبلَّغ عنه",
  "Measured by": "يقيسه",
  "On a breach": "عند الإخلال",
  "Signed copy, uploaded from the contracts register": "نسخة موقّعة، مرفوعة من سجل العقود",
  "The document library did not take the copy ({why}); it is kept in this browser.":
    "لم تقبل مكتبة الوثائق النسخة ({why})؛ وهي محفوظة في هذا المتصفح.",
  "Edit the contract": "تعديل العقد",
  "Scope, service levels and term only. The register refuses any price, rate or amount — the signed copy carries those, and it is filed as a restricted document.":
    "النطاق ومستويات الخدمة والمدة فقط. يرفض السجل أي سعر أو تعرفة أو مبلغ — فهي في النسخة الموقّعة، التي تُحفظ كوثيقة مقيّدة.",
  "Standard, e.g. within 15 minutes for 95% of flights": "المعيار، مثال: خلال 15 دقيقة لـ 95% من الرحلات",
  "On a breach, in words": "عند الإخلال، بالكلمات",
  "Add a service level": "أضف مستوى خدمة",
  "Attached: {name}. Choose a file to replace it; the earlier copy stays in the history.":
    "مرفق: {name}. اختر ملفاً لاستبداله؛ تبقى النسخة السابقة في السجل.",
  "Save the contract": "احفظ العقد",
  "{n} provider|{n} providers": "لا مقدمي خدمات|مقدم خدمة واحد|مقدما خدمة|{n} مقدمي خدمات|{n} مقدم خدمة|{n} مقدم خدمة",
  "Ground handling": "المناولة الأرضية",
  Fuel: "الوقود",
  Catering: "التموين",
  Cleaning: "النظافة",
  "IT and systems": "تقنية المعلومات والأنظمة",
  "Construction and works": "الإنشاءات والأعمال",
  "Government agency": "جهة حكومية",
  "Ends on its expiry date": "ينتهي في تاريخ انتهائه",
  "Renews automatically unless notice is given": "يتجدد تلقائياً ما لم يُقدَّم إشعار",
  "Can be extended by option": "قابل للتمديد بخيار",
  "Each occurrence": "كل حدوث",
  Daily: "يومياً",
  Weekly: "أسبوعياً",
  Monthly: "شهرياً",
  Quarterly: "ربع سنوي",
  Annually: "سنوياً",
  "Not started": "لم يبدأ",
  "In force": "ساري",
  "Notice decision due": "قرار الإشعار مستحق",
  Expiring: "قارب الانتهاء",
  "No expiry recorded": "لا تاريخ انتهاء مسجّل",
  "Name the provider.": "اذكر مقدم الخدمة.",
  "Give the contract a title.": "أعطِ العقد عنواناً.",
  "Describe the scope — what the provider does.": "صِف النطاق — ما يقوم به مقدم الخدمة.",
  "The notice period is a number of days, 0 to 730.": "مدة الإشعار عدد أيام، من 0 إلى 730.",
  "Each service level needs what is measured and the standard.": "كل مستوى خدمة يحتاج إلى ما يُقاس والمعيار.",
  "This register holds no financial terms. Remove the figure: “{text}”.":
    "لا يحتوي هذا السجل على شروط مالية. احذف الرقم: «{text}».",
  "The contract ends before it starts.": "ينتهي العقد قبل أن يبدأ.",
  "The contract has expired": "انتهى العقد",
  "The provider's insurance has expired": "انتهى تأمين مقدم الخدمة",
  "No service levels recorded": "لا مستويات خدمة مسجّلة",
  "No signed copy attached": "لا نسخة موقّعة مرفقة",
  "No contract owner named": "لم يُسمَّ مسؤول العقد",
  "No insurance expiry recorded": "لا تاريخ انتهاء تأمين مسجّل",
  "The notice deadline has passed: it renews": "فات موعد الإشعار: سيتجدد",
  "No expiry date recorded": "لا تاريخ انتهاء مسجّل",
  Exclusions: "الاستثناءات",
  "Contract title": "عنوان العقد",
  "E-mail": "البريد الإلكتروني",
  Phone: "الهاتف",
  "Notice period, days": "مدة الإشعار، بالأيام",
  "Scope — what the provider does": "النطاق — ما يقوم به مقدم الخدمة",
  "Services, one per line": "الخدمات، كل خدمة في سطر",
  "Signed copy — PDF, Word or an image": "النسخة الموقّعة — PDF أو Word أو صورة",
  "Why it changed (optional)": "سبب التغيير (اختياري)",
};
export default ar;
